module.exports = __webpack_public_path__ + "img/restaurant_signaturemenu_image21.2d9549b7.jpg";